import React from 'react';
import PropTypes from 'prop-types';
import {
  DatePicker
} from 'antd';

import styles from './DateRange.module.css';

const { RangePicker } = DatePicker;

const DateRange  = ({
  defaultValue,
  handleChange,
}) => (
  <div className={styles.rangepicker}>
    <span className={styles.label}>Date:</span>
    <RangePicker
      defaultValue={defaultValue}
      onChange={handleChange}
      allowClear={false}
      className={styles.control}
    />
  </div>
);

DateRange.propTypes = {
  defaultValue: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default DateRange;
